import { CSSProperties, PureComponent, ReactNode } from "react";
import ReactFastMarquee from "react-fast-marquee";

export interface IMarqueeBodyWrapperProps {
  speed?: number;
  autoFill?: boolean;
  pauseOnHover?: boolean;
  pauseOnClick?: boolean;
  gradientColor?: string;
  gradientWidth?: number;
  style?: CSSProperties;
  children?: ReactNode;
}

export interface IMarqueeBodyWrapperState {}

declare let window: Window & { [key: string]: any };

export class Marquee extends PureComponent<IMarqueeBodyWrapperProps, IMarqueeBodyWrapperState> {
  constructor(props) {
    super(props);
  }

  getProps = () => {
    const { style, speed, autoFill, pauseOnHover, pauseOnClick, gradientColor, gradientWidth, children } = this.props;
    const props: IMarqueeBodyWrapperProps = {};

    props.autoFill = autoFill;
    props.style = { ...style };
    props.speed = speed;
    props.pauseOnHover = pauseOnHover;
    props.pauseOnClick = pauseOnClick;
    props.gradientColor = gradientColor;
    props.children = children;

    if (gradientWidth === null || gradientWidth === undefined || gradientWidth < 0) props.gradientWidth = 0;
    else props.gradientWidth = gradientWidth;

    if (props.style) {
      props.style.display = "flex";
    }

    if (window.kuika?.isDesignTime) {
      props.speed = 0;
    }

    return props;
  };

  render(): ReactNode {
    return <ReactFastMarquee {...this.getProps()} gradient />;
  }
}
